import qs from "qs";
import {TOKEN_KEY, SERVICE_KEY} from "../constant";

/**
 * 获取查询参数
 * @param str 查询参数字符串
 * @returns
 */
export const getSearchParams = (str) => {
  const searchStr = str ?? window.location.search;
  return qs.parse(searchStr.replace(/^\?/, ""));
};

/**
 * 获取登陆url
 */
export const getSSOUrl = (type = "login") => {
  const service = encodeURIComponent(
    window.location.href.replace(/\/$/, "") + "/home"
  );
  // const url = `${process.env.REACT_APP_SSO_HOST}/sso/${type}?service=${service}`;
  const url =
    type === "register"
      ? `${process.env.REACT_APP_SSO_HOST}/sso/${type}?service=${service}`
      : `${process.env.REACT_APP_SSO_HOST_LOGIN}/sso/index.html?service=${service}`;
  return url;
};

/**
 * 跳转 sso 登陆
 */
export const toSSO = (type) => {
  // 移除无效token
  localStorage.removeItem(TOKEN_KEY);
  // 存储 toSSO 跳转前页面地址
  localStorage.setItem(
    SERVICE_KEY,
    window.location.href.replace(/\/$/, "") + "/home"
  );

  window.location.assign(getSSOUrl(type));
};

/**
 * get Ticket
 */
export const getTicket = () => {
  const params = getSearchParams();
  return params?.ticket;
};
